var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0051C2 11.6504 2.15617 11.2856 2.41645 11.0424L9.2254 4.41545C9.51692 4.13173 9.85008 4 10.1832 4C10.9537 4 11.4951 4.53705 11.4951 5.23623C11.4951 5.62128 11.3285 5.92527 11.089 6.16846L8.72566 8.47878L6.09162 10.8296L8.43415 10.708H20.6257C21.4482 10.708 22 11.235 22 12.0051C22 12.7752 21.4482 13.3021 20.6257 13.3021H8.43415L6.09162 13.1704L8.72566 15.5313L11.089 17.8315C11.3285 18.0747 11.4951 18.3787 11.4951 18.7638C11.4951 19.4731 10.9537 20 10.1832 20C9.85008 20 9.52733 19.8683 9.24623 19.5947L2.41645 12.9677C2.15617 12.7144 2 12.3597 2 12.0051Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-left.c27fba31b789e40b01e270783a93415e.svg";